import { flatToQueryString, getUrlWithSchema } from "@shared/common/utils/url";
import type { ExternalSiteRule } from "../../types";
import { MAKESHOP_PAGE, SITE_TYPE } from "./const";

const makeshop: ExternalSiteRule = {
  type: SITE_TYPE,

  getInfo: async ({ html, responseUrl }) => {
    if (!html.innerHTML.includes("makeshop_wishlist")) {
      return "INVALID";
    }

    return {
      siteType: SITE_TYPE,
      url: responseUrl,
      siteInfo: {
        type: SITE_TYPE,
      },
    };
  },

  pageRules: [
    {
      siteType: SITE_TYPE,
      targetValue: MAKESHOP_PAGE.LOGIN.target,
      label: "로그인 페이지 - 메인",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${
          MAKESHOP_PAGE.LOGIN.url
        }${flatToQueryString(MAKESHOP_PAGE.LOGIN.params)}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: MAKESHOP_PAGE.LOGIN_MY_PAGE.target,
      label: "로그인 페이지 - 마이 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${
          MAKESHOP_PAGE.LOGIN_MY_PAGE.url
        }${flatToQueryString(MAKESHOP_PAGE.LOGIN_MY_PAGE.params)}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: MAKESHOP_PAGE.SIGNUP.target,
      label: "가입하기 페이지 - 메인",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${MAKESHOP_PAGE.SIGNUP.url}`;
      },
    },

    {
      siteType: SITE_TYPE,
      targetValue: MAKESHOP_PAGE.SIGNUP_COMPLETE.target,
      label: "가입하기 완료 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${
          MAKESHOP_PAGE.SIGNUP_COMPLETE.url
        }`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: MAKESHOP_PAGE.FIND_PASSWORD.target,
      label: "비밀번호 찾기 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${MAKESHOP_PAGE.FIND_PASSWORD.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: MAKESHOP_PAGE.MY_PAGE.target,
      label: "마이 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${MAKESHOP_PAGE.MY_PAGE.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: MAKESHOP_PAGE.FAQ.target,
      label: "자주 묻는 질문 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${MAKESHOP_PAGE.FAQ.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: MAKESHOP_PAGE.CART.target,
      label: "장바구니 페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${MAKESHOP_PAGE.CART.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: MAKESHOP_PAGE.PRODUCT_LIST.target,
      label: "상품 목록 페이지",
      getExactUrl({ siteUrl, params }) {
        if (params?.productSlug) {
          return `${getUrlWithSchema(siteUrl)}${
            MAKESHOP_PAGE.PRODUCT_LIST.url
          }?${params.productSlug}`;
        }
        return `${getUrlWithSchema(siteUrl)}${
          MAKESHOP_PAGE.PRODUCT_LIST.url
        }?...`;
      },
      allowDuplicate: true,
      params: [
        {
          key: "productSlug",
          formType: "TEXT",
          placeholder: "/하위경로를 입력해주세요",
        },
      ],
    },
    {
      siteType: SITE_TYPE,
      targetValue: MAKESHOP_PAGE.PRODUCT_DETAIL.target,
      label: "상품 상세 페이지",
      getExactUrl({ siteUrl, params }) {
        if (params?.productSlug) {
          return `${getUrlWithSchema(siteUrl)}${
            MAKESHOP_PAGE.PRODUCT_DETAIL.url
          }?${params.productSlug}`;
        }
        return `${getUrlWithSchema(siteUrl)}${
          MAKESHOP_PAGE.PRODUCT_DETAIL.url
        }?...`;
      },
      allowDuplicate: true,
      params: [
        {
          key: "productSlug",
          formType: "TEXT",
          placeholder: "/하위경로를 입력해주세요",
        },
      ],
    },
  ],
};

export default makeshop;
